import { render, staticRenderFns } from "./AbsencePlanAdd.vue?vue&type=template&id=5831a6ec&scoped=true&"
import script from "./AbsencePlanAdd.vue?vue&type=script&lang=js&"
export * from "./AbsencePlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831a6ec",
  null
  
)

export default component.exports